import React, { type PropsWithChildren, type FC } from 'react';

import type { Interpolation } from '@emotion/react';

import type { Lucid } from '../../../types/types';
import Heading, { type HeadingProps } from '../../heading/heading';

export type CardHeadingProps = HeadingProps & {
  /** Allows the Card Heading to receive additional styles */
  css?: Interpolation<Lucid.Theme.Brand>;
  /** The string value to be passed as the Heading inner HTML */
  heading?: string;
  /** The Heading variant */
  variant?: Extract<Lucid.Theme.Component.Typography.Heading.VariantKeys, 'headingS' | 'headingM' | 'headingL'>;
};

const CardHeading: FC<PropsWithChildren<CardHeadingProps>> = ({ as, heading, variant = 'headingM', ...rest }) =>
  heading && (
    <Heading {...rest} as={as} data-card-element="heading" variant={variant}>
      {heading}
    </Heading>
  );

export { CardHeading };
export default CardHeading;
